import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetMenuList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'Menu/GetAllMenuList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewMenu = async (menuDet) => {
    //debugger;
    //console.log(JSON.stringify(menuDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Menu/CreateNewMenu`, 
        JSON.stringify(menuDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateMenu = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Menu/ActivateDeActivateMenu?MenuId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateMenu = async(menuDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'Menu/UpdateMenu', 
        JSON.stringify(menuDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}

export const GetMappedUnMappedMenu_RoleList = async(Id) => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Menu/GetMappedUnMappedMenu_RoleList?menuId=${Id}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const MapMenu_Role = async(MenuRoleMappingDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'Menu/MapMenu_Role', 
        JSON.stringify(MenuRoleMappingDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}

export const SendMenuOTP = async(payload) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'Menu/SendMenuOTP',
            JSON.stringify(payload),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}

export const VerifyOtp = async(otp) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'Menu/VerifyOtp', 
        JSON.stringify(otp),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}